export const FETCH_DOCUMENTS = 'trash/FETCH_DOCUMENTS';
export const FETCH_DOCUMENTS_SUCCESS = 'trash/FETCH_DOCUMENTS_SUCCESS';
export const FETCH_DOCUMENTS_ERROR = 'trash/FETCH_DOCUMENTS_ERROR';

export const FETCH_FOLDERS = 'trash/FETCH_FOLDERS';
export const FETCH_FOLDERS_SUCCESS = 'trash/FETCH_FOLDERS_SUCCESS';
export const FETCH_FOLDERS_ERROR = 'trash/FETCH_FOLDERS_ERROR';

export const RESTORE_DOCUMENTS = 'trash/RESTORE_DOCUMENTS';
export const RESTORE_DOCUMENTS_SUCCESS = 'trash/RESTORE_DOCUMENTS_SUCCESS';
export const RESTORE_DOCUMENTS_ERROR = 'trash/RESTORE_DOCUMENTS_ERROR';
